










































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BlockView from '../components/blockView.vue';
import UploadImage from '../components/uploadImage.vue';
import Vuedraggable from 'vuedraggable';
import quill from '../components/quill.vue';

@Component({
  components:{
    BlockView,
    quill,
    UploadImage,
    Vuedraggable,
  }
})
export default class Graphic extends Vue {
  $bus: any;
  @Prop(Object) goodsInfo!: object;
  @Watch('goodsInfo',{immediate:true,deep:true})
  onPersonChanged(val: object){
    this.graphicData=val;
  }
  graphicData: object = {};//传递过来的数据
  outerVisible: boolean = false;//弹窗

  imageUrl: string = '';//图片url
  spuSkuImages: Array<object> = [];//图片组
  isShowUploadDialog: boolean = false;//是否显示上传图片组件
   dragOptions: object = {
    //拖拽器配置
    animation: 300,
    group: 'description',
    ghostClass: 'ghost',
  };
  /**
   *上传图片确认
   *
   */
  uploadConfirm(imgs) {
    this.graphicData['spuSkuImages'] = imgs;
  }
  closeUpload() {
    this.isShowUploadDialog = false;
  }
  /**
   *富文本编辑器内容发生变更
   *
   */
  onEditorChange(val) {
    this.graphicData['info'] = val;
  }
  /* 全屏富文本 */
  fullScreen(){
    this.outerVisible=true;
  }
  /* 退出全屏 */
  narrow(){
    this.outerVisible=false;
  }
    /**
   *删除图片
   *
   */
  deleteImg(index): void {
    const tempImgs = [...this.goodsInfo['spuSkuImages']];
    tempImgs.splice(index, 1);
    this.goodsInfo['spuSkuImages'] = tempImgs;
  }
}
